// extracted by mini-css-extract-plugin
export default {"TanklessDesktopCatalogFilter":"styles_TanklessDesktopCatalogFilter__sINLY"};